import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import StepsCreateError from "newApp/components/StepsCreateError";
import StepsForm from "newApp/components/StepsForm";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import { URL_ADMINISTRATION_STEPS } from "newApp/routing/urls";
import { StepCreatePage } from "newApp/stores/pages/administrations/steps/StepCreatePage";
import React, { useEffect } from "react";
import { useHistory } from "react-router";

const store = new StepCreatePage();

const StepsCreatePage: React.FC = () => {
  const { push } = useHistory();

  useEffect(() => {
    store.init();
    return () => store.reset();
  }, []);

  const onClickCreate = async () => {
    const result = await store.onCreate();
    if (result) {
      push(URL_ADMINISTRATION_STEPS);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const goOnList = () => push(URL_ADMINISTRATION_STEPS);

  return (
    <MainLayout>
      <H1>Конструктор шагов</H1>
      <FlexColumn>
        <ButtonBack url={URL_ADMINISTRATION_STEPS}>Назад к списку</ButtonBack>
        <StepsCreateError error={store.error} onCloseClick={store.resetError} />
        <StepsForm {...store.stepsForm} />
        <ButtonsContainer>
          <Button onClick={onClickCreate}>Создать</Button>
          <Button onClick={goOnList} variant="secondary">
            Отменить
          </Button>
        </ButtonsContainer>
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(StepsCreatePage);
